"use client";

import NextLink from "next/link";
import { useSearchParams } from "next/navigation";
import { Suspense } from "react";
import { useLang, useUi } from "@/components/ui/use-ui";
import { useSitePath } from "@/components/ui/use-site-path";
import { cn } from "@/lib/cn";
import { LOCALE_NAMES, LOCALES, localePath } from "@/lib/i18n";

/** The same page in each of the site's languages (lib/i18n.ts). */
export function LanguageMenu({ className }: { className?: string }) {
  return (
    <Suspense fallback={null}>
      <Languages className={className} />
    </Suspense>
  );
}

function Languages({ className }: { className?: string }) {
  const t = useUi();
  const lang = useLang();
  const path = useSitePath();
  const query = useSearchParams().toString();
  return (
    <nav aria-label={t.nav.language} className={cn("flex flex-wrap gap-x-3 gap-y-1.5 text-[12px] text-muted", className)}>
      {LOCALES.map((l) => (
        <NextLink
          key={l}
          href={`${localePath(l, path)}${query ? `?${query}` : ""}`}
          hrefLang={l}
          lang={l}
          aria-current={l === lang ? "true" : undefined}
          className={cn("whitespace-nowrap hover:text-fg", l === lang && "text-fg")}
        >
          {LOCALE_NAMES[l]}
        </NextLink>
      ))}
    </nav>
  );
}
